import React from "react";
import TopBarLogoSvg from "../../assets/svgicons/OTP-icon-top-bar-logo-desktop.svg";

const FooterLogoIcon = () => {
	return <img src={TopBarLogoSvg} width={138} style={{}} alt="TopBarLogo" />;
};

export default FooterLogoIcon;
